import React, { useEffect, useState } from 'react';
import CheckUserType from '../Functions/CheckUserType';
import { useNavigate } from 'react-router-dom';

function GMFHome() {
    const role = 'GMF';
    const navigate = useNavigate();

    useEffect(() => {
        // CheckUserType(role, navigate);
    }, [role, navigate]);

    return (
        <div>
            <p>GMF home page</p>
        </div>
    );
}

export default GMFHome;
